import version1 from "./version1";

export default [version1];
